<template>
    <svg :class="design" :width="width" :height="height" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.07812 1.07812L1.31836 5.34375C1.08105 5.51953 0.9375 5.80078 0.9375 6.09668V6.19043L1.23633 6.43359L6.9668 11.1416C7.11621 11.2646 7.30664 11.332 7.5 11.332C7.69336 11.332 7.88379 11.2646 8.0332 11.1416L13.7637 6.43359L14.0625 6.19043V6.09668C14.0625 5.80078 13.9219 5.51953 13.6816 5.34375L7.92188 1.07812C7.79883 0.987305 7.65234 0.9375 7.5 0.9375C7.34766 0.9375 7.19824 0.987305 7.07812 1.07812ZM0.9375 7.40332V13.125C0.9375 13.6436 1.35645 14.0625 1.875 14.0625H13.125C13.6436 14.0625 14.0625 13.6436 14.0625 13.125V7.40332L8.62793 11.8682C8.31152 12.1289 7.91016 12.2725 7.5 12.2725C7.08984 12.2725 6.68848 12.1289 6.37207 11.8682L0.9375 7.40332ZM6.51855 0.322266C6.80273 0.114258 7.14551 0 7.5 0C7.85449 0 8.19727 0.114258 8.48145 0.322266L14.2412 4.59082C14.7188 4.94531 15 5.50195 15 6.09668V13.125C15 14.1592 14.1592 15 13.125 15H1.875C0.84082 15 0 14.1592 0 13.125V6.09668C0 5.50195 0.28125 4.94238 0.758789 4.59082L6.51855 0.322266Z" :fill="fill"/>
    </svg>
</template>
<script>
export default {
    name: 'ui-email-icon',
    props: {
        fill: {
            type: String,
            default: '#EAAF40'
        },
        design: {
            type: String,
            default: ''
        },
        width: {
            type: [String, Number],
            default: 15
        },
        height: {
            type: [String, Number],
            default: 15
        }
    }
}
</script>